<div class="playback-container">
  <div  class="playback-header">
    <div class="menu-hover">
      <div></div>
    </div>
    <button (click)="onLogClick($event)" mat-flat-button class="primary-button" [class.selected]="logVisible">{{'archive:Log' | i18next}}</button>
    <button (click)="onConfigClick($event)" mat-flat-button class="primary-button" [class.selected]="configVisible">{{'archive:Config' | i18next}}</button>
  </div>
  <div  class="playback-content">
    <app-archive-external-access-logs *ngIf="logVisible"></app-archive-external-access-logs>
    <app-archive-external-access-config *ngIf="configVisible"></app-archive-external-access-config>
  </div>
</div>
